// src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

// Create Context
const AuthContext = createContext();

// AuthProvider component to wrap around your app
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // State to store user data

    //Constant Checking if user is still Logged-in
    useEffect(() => {
        let isMounted = true;

        const fetchUserData = async() => {
            const role = localStorage.getItem("role");
            if(!role) {
                console.log("No role found. User is not logged in.");
                return;
            }

            console.log("Fetch User Data: Role ", role)

            const token = localStorage.getItem("token");
            if (!token && role === 'Admin') {
                console.log("No token found. User is not logged in.");
                setUser(null);
                return;
            }

            console.log("Fetch User Data: Token ", token)

            try {
                let response;
                if (role === 'User' || role === 'Applicant') {
                    console.log("Log in in as a User");
                    response = await axios.get(`https://cleanez-api.vercel.app/api/user/getAccountInformation`,{
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (isMounted) {
                        console.log(response.data.user);
                        setUser({...response.data.user});
                    }
                } else if (role === 'Worker') {
                    console.log("Log in in as a Worker");
                    response = await axios.get(`https://cleanez-api.vercel.app/api/worker/getWorkerAccountInformation`,{
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (isMounted) {
                        console.log(response.data.user.user);
                        setUser({...response.data.user.user});
                    }
                }
                
                

            } catch (e) {
                console.log(e);
            }
        }

        fetchUserData();

        return () => {
            isMounted = false;
        };
    }, [])

    const login = (userData) => {
        setUser(userData); // Store the user data after successful login
    };

    const logout = async () => {
        setUser(null); // Clear user data on logout

        const response = await axios.post('https://cleanez-api.vercel.app/api/auth/logout',
            {
            headers: { 'Content-Type': 'application/json' }
          });

          console.log(response.data); // Checks if cookie has been cleared
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to access authentication state
export const useAuth = () => {
    return useContext(AuthContext);
};
